export default "__VITE_ASSET__DJfi8X5C__"